module.exports = __webpack_public_path__ + "img/illustrator-noData.42384144.svg";